import { render } from "./UsersIndex.vue?vue&type=template&id=4a238054"
import script from "./UsersIndex.vue?vue&type=script&lang=js"
export * from "./UsersIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/seguridad/UsersIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a238054"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a238054', __exports__)) {
    api.reload('4a238054', __exports__)
  }
  
  module.hot.accept("./UsersIndex.vue?vue&type=template&id=4a238054", () => {
    api.rerender('4a238054', render)
  })

}


export default __exports__